import { getPlatformFromUrl } from '@adsk/acs-sc-web-platform-api';
import { Pendo } from '@adsk/acs-web-onboarding';

/** @typedef {import('@adsk/alloy-provider').EntitlementsUser} EntitlementsUser */
/** @typedef {import('@adsk/acs-web-onboarding').Pendo.Context} PendoContext */
/** @typedef {{ user: EntitlementsUser; context?: PendoContext;  }} InitializePendoParams */

/**
 *
 * Initialize Pendo only in ACC
 *
 * @param {InitializePendoParams} params
 */
export function initialize(_ref) {
  let {
    user,
    context
  } = _ref;
  const isACC = getPlatformFromUrl() === 'acc';
  if (!isACC) {
    return;
  }
  Pendo.initialize(user, context);
}
//# sourceMappingURL=pendo.js.map